module.exports = __webpack_public_path__ + "media/images/amenities_icons/hammock-34d07e10d6293741a072e25e8d72eae1.svg";